document.addEventListener("DOMContentLoaded", (event) => {
  
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  let isMobile = false;
  
  window.addEventListener('resize', () => {
    isMobile = (window.matchMedia("(max-width:1024px)").matches) ? true : false;
    window.dispatchEvent(new Event('scroll'));
  });
  window.dispatchEvent(new Event('resize'));

  // Collection bar
  const swiperCollectionBar = new Swiper('.collection__menu', {
    // Existing options
    slidesPerView: 'auto',
    freeMode: {
      enabled: true,
      sticky: true,
      momentumBounce: false,
      momentumRatio: 1,
      momentumVelocityRatio: 1
    },
    resistance: true,
    resistanceRatio: 0.7,
    speed: 500,
    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 'auto',
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 'auto',
        spaceBetween: 15,
      }
    },
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    preventClicks: false,
    preventClicksPropagation: false,
  });
  
  // Active Collection menu
  const slides = document.querySelectorAll('.collection__menu .swiper-slide');
  let anyActive = false;
  
  slides.forEach(slide => {
    if (slide.classList.contains('active')) {
      anyActive = true;
    }
  });

  if (!anyActive && slides.length > 1) {
    slides[1].classList.add('active');
    setTimeout(()=>{
      document.querySelectorAll('.collection__menu').forEach(el => {
        el.style.visibility = 'visible';
      });
    },100)
  }
  // END Active Collection menu

  // Collection filters toggle 
  const allFilters = document.querySelectorAll('.js-filter');
  if ( allFilters ) {
    allFilters.forEach(details => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        allFilters.forEach(other => {
          if (other !== details) other.open = false;
        });
      });
    });
  }
  
  // SEO description 
  // const seoInfo = document.querySelector('#seo-info');
  // if (seoInfo) {
    
  //   const seoTemplate = document.getElementById('seo-template');
  //   const tipInstance = tippy(seoInfo, {
  //     content: seoTemplate.innerHTML,
  //     trigger: 'mouseenter',
  //     placement: 'auto',
  //     allowHTML: true,
  //     arrow: true,
  //     interactiveBorder: 100
  //   });
  // }
});

// Storytelling video autoplay
function handleScrollVideos() {
  var videos = document.querySelectorAll('.custom-autoplay-video');
  var windowHeight = window.innerHeight || document.documentElement.clientHeight;

  for (var i = 0; i < videos.length; i++) {
    var video = videos[i];
    var rect = video.getBoundingClientRect();
    var visible = rect.top < windowHeight * 0.75 && rect.bottom > windowHeight * 0.25;

    if (visible) {
      if (video.paused) {
          video.play().catch(function() { 
            // console.log('Autoplay blocked'); 
          });
      }
    } else {
      if (!video.paused) {
          video.pause();
      }
    }
  }
}

window.addEventListener('scroll', handleScrollVideos);
window.addEventListener('resize', handleScrollVideos);
document.addEventListener('DOMContentLoaded', handleScrollVideos);

var mutationObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    for (var j = 0; j < mutation.addedNodes.length; j++) {
    var node = mutation.addedNodes[j];
      if (node.nodeType === 1) {
        if (node.classList.contains('custom-autoplay-video')) {
          handleScrollVideos();
        } else if (node.querySelectorAll) {
          var nestedVideos = node.querySelectorAll('.custom-autoplay-video');
          for (var k = 0; k < nestedVideos.length; k++) {
            handleScrollVideos();
          }
        }
      }
    }
  }); 
});
mutationObserver.observe(document.body, { childList: true, subtree: true });

// Remove invis products
// setTimeout(() => {
//   document.querySelectorAll('.product.invis').forEach(el => el.remove());
// }, 100);

const collectionOrigFetch = window.fetch;
window.fetch = function() {
  const url = arguments[0];
  if (typeof url === "string" && url.includes("/collections/")) {
    // console.log("Fetching collection products:", url);
  }
  return collectionOrigFetch.apply(this, arguments).then(res => {
    if (res.url.includes("/collections/")) {
      // console.log("Collection products fetched:", res.url);
      setTimeout(()=>{

        // loadSpotlightHighlightVariantsFromMetafield().then(() => {
          // setTimeout(() => {
          //   document.querySelector('.collection-loader')?.classList.remove('active');
          // }, 500);
        // });

        // const variantProductsMap = new Map();
        // document.querySelectorAll('.products-list > li.product[data-variant-products]').forEach(li => {

        //   if (!li.classList.contains('spotlight') && !li.classList.contains('highlight')) return;

        //   const variantHandles = li.dataset.variantProducts
        //     .split(',')
        //     .map(h => h.trim())
        //     .filter(Boolean)
        //     .sort((a, b) => a.localeCompare(b));

        //   const variantKey = variantHandles.join(',');
        //   if (!variantProductsMap.has(variantKey)) {
        //     variantProductsMap.set(variantKey, {
        //       spotlight: null,
        //       highlight: null
        //     });
        //   }

        //   const variantSet = variantProductsMap.get(variantKey);
        //   const type = li.classList.contains('spotlight') ? 'spotlight' : 'highlight';
          
        //   if (!variantSet[type]) {
        //       variantSet[type] = li;
        //   } else {
        //       li.classList.add('to-remove');
        //   }
        // });
        // document.querySelectorAll('.to-remove').forEach(li => {
        //     li.remove();
        // });

      }, 50)
    }
    return res;
  });

  async function loadSpotlightHighlightVariantsFromMetafield(container = document) {
    
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isMobile = (window.matchMedia("(max-width:1024px)").matches) ? true : false;
    const cards = container.querySelectorAll('.product.spotlight, .product.highlight');
    // const usedProductHandles = new Set();

    const usedVariantIds = {
      spotlight: new Set(),
      highlight: new Set()
    };

    // Get products from window.collectionData
    const { spotlight = [], highlight = [] } = window.collectionData || {};
    console.log('Spotlight products:', spotlight);
    console.log('Highlight products:', highlight);

    const cardData = Array.from(cards)
      .filter(card => card.dataset.loaded !== 'true')
      .map(card => {
          const variantHandles = card.dataset.variantProducts;
          if (!variantHandles) return null;

          const handles = variantHandles
              .split(',')
              .map(h => h.trim())
              .filter(Boolean);

          if (!handles.length) return null;

          const isSpotlight = card.classList.contains('spotlight');
          const type = isSpotlight ? 'spotlight' : 'highlight';
          const productsArray = isSpotlight ? spotlight : highlight;

          // Get available variants from the appropriate array
          const availableVariants = handles
              .map(handle => {
                  const product = productsArray.find(p => p && p.handle === handle);
                  return product ? {
                      handle: product.handle,
                      variantId: product.id?.toString(),
                      product: product
                  } : null;
              })
              .filter(Boolean)
              .filter(v => !usedVariantIds[type].has(v.variantId));

          if (!availableVariants.length) return null;

          // Mark these variants as used in this type
          availableVariants.forEach(v => {
              usedVariantIds[type].add(v.variantId);
          });

          return {
              element: card,
              handles: availableVariants.map(v => v.handle),
              isSpotlight,
              products: availableVariants.map(v => v.product)
          };
      })
      .filter(Boolean);

    // Process each card
    for (const { element: card, handles, isSpotlight } of cardData) {
      
      card.dataset.loaded = 'true';
        
      // Get the appropriate products array
      const productsArray = isSpotlight ? spotlight : highlight;
      console.log(`Processing ${isSpotlight ? 'spotlight' : 'highlight'} card with handles:`, handles);
      console.log('Available products:', productsArray);

      // REMOVE DUPLICATES with different order in data-variant-products

      // const variantProductsMap = new Map();

      // // Process both spotlight and highlight products
      // container.querySelectorAll('.products-list > li.product[data-variant-products]').forEach(li => {
      //   // Only process spotlight and highlight products
      //   if (!li.classList.contains('spotlight') && !li.classList.contains('highlight')) return;

      //   const variantHandles = li.dataset.variantProducts
      //     .split(',')
      //     .map(h => h.trim())
      //     .filter(Boolean)
      //     .sort()
      //     .join(',');

      //   if (!variantProductsMap.has(variantHandles)) {
      //     variantProductsMap.set(variantHandles, []);
      //   }
      //   variantProductsMap.get(variantHandles).push(li);
      // });

      // // Mark duplicates with .to-remove
      // variantProductsMap.forEach(duplicates => {
      //   if (duplicates.length > 1) {
      //     // Keep the first one, mark the rest
      //     duplicates.slice(1).forEach(li => {
      //       li.classList.add('to-remove');
      //       // li.remove();
      //     });
      //   }
      // });


      // V2 Create a map to track unique variant sets
      const variantProductsMap = new Map();

      // Process both spotlight and highlight products
      container.querySelectorAll('.products-list > li.product[data-variant-products]').forEach(li => {
        // Only process spotlight and highlight products
        if (!li.classList.contains('spotlight') && !li.classList.contains('highlight')) return;

        // Get and sort variant handles
        const variantHandles = li.dataset.variantProducts
            .split(',')
            .map(h => h.trim())
            .filter(Boolean)
            .sort((a, b) => a.localeCompare(b)); // Consistent sorting

        // Create a unique key for this set of variants
        const variantKey = variantHandles.join(',');

        // Track which product types (spotlight/highlight) we've seen for this variant set
        if (!variantProductsMap.has(variantKey)) {
            variantProductsMap.set(variantKey, {
                spotlight: null,
                highlight: null
            });
        }

        const variantSet = variantProductsMap.get(variantKey);
        const type = li.classList.contains('spotlight') ? 'spotlight' : 'highlight';
        
        // If we haven't seen this type for this variant set yet, keep it
        if (!variantSet[type]) {
            variantSet[type] = li;
        } else {
            // If we've already seen this type for this variant set, mark as duplicate
            li.classList.add('to-remove');
        }
      });

      // Remove duplicates
      document.querySelectorAll('.to-remove').forEach(li => {
          li.remove();
      });

      // END REMOVE DUPLICATES

      // Get products that match the filtered handles
      const relatedProducts = productsArray.filter(p => 
        p && p.handle && handles.includes(p.handle)
      );

      console.log('Matched products:', relatedProducts);

      const relatedHandles = new Set(relatedProducts.map(p => p.handle));
      
      document.querySelectorAll('.products-list > li.product:not(.highlight):not(.spotlight)').forEach(li => {
        const handle = li.dataset.handle;
        if (handle && relatedHandles.has(handle)) {
          li.remove();
        }
      });

      if (!relatedProducts.length) continue;
 
      // Spotlight
      if( card.classList.contains('spotlight') ) {
         
        const thumbsContainer = card.querySelector('.variant-thumbnails');
        if (!thumbsContainer) continue;

        thumbsContainer.innerHTML = '';
        thumbsContainer.classList.remove('loaded');

        relatedProducts.forEach((product, index) => {

          if (!product.available) return;

          const images = Array.isArray(product.images) && product.images.length
            ? product.images
            : product.featuredImage
              ? [product.featuredImage]
              : []; // fallback empty array

          if (!images.length) return; // skip if still no images

          // console.log('spotlight:', product)

          const link = document.createElement('a');
          link.classList.add('variant-spotlight');
          // if (index === 0) link.classList.add('active');
          link.href = product.handle ? `/products/${product.handle}` : '#';
          link.dataset.productHandle = product.handle;
          link.dataset.productVariantId = product.id;
          link.dataset.productVariantPrice = formatPriceEUR(product);
          link.setAttribute('data-product-variant-images', JSON.stringify(images));

          const img = document.createElement('img');
          img.src = product.featuredImage;
          img.alt = product.title;
          img.width = isMobile ? '90' : '100';
          img.height = isMobile ? '90' : '100';

          if (product.images?.length) {
            img.classList.add('variant-thumb');
            img.src = images[0];
            img.srcset = product.images.map(url => `${url} 500w`).join(', ');
          }

          link.appendChild(img);
          thumbsContainer.appendChild(link);
          showVariantThumbnailsSmoothly(thumbsContainer);

          // Trigger interaction for the first link
          if (index === 0) {
            setTimeout(() => {
              const eventType = isTouch ? 'click' : 'mouseover';
              if( isTouch ) {
                // link.dispatchEvent(new Event(eventType, { bubbles: true }));
              } else {
                // link.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
              }
              link.classList.add('active');
            }, 100);
          }
        });
      }

      // Highlight
      if( card.classList.contains('highlight') ) {

        const thumbsContainer = card.querySelector('.variant-thumbnails');
        if (!thumbsContainer) continue;

        thumbsContainer.innerHTML = '';
        thumbsContainer.classList.remove('loaded');

        // Get the current product's container ID
        const baseContainer = card.querySelector('.product-tile__container');
        const baseId = baseContainer ? baseContainer.getAttribute('id') : null;

        relatedProducts.forEach((product, index) => {

          if (!product.available) return;

          const images = Array.isArray(product.images) && product.images.length
            ? product.images
            : product.featuredImage
              ? [product.featuredImage]
              : []; // fallback empty array

          if (!images.length) return; // skip if still no images

          // console.log('highlight:', product)

          const link = document.createElement('a');
          link.classList.add('variant-highlight');
          if (index === 0) link.classList.add('active');
          link.href = product.handle ? `/products/${product.handle}` : '#';
          link.dataset.productUrl = link.href;
          link.dataset.productVariantId = product.id;
          link.dataset.productVariantFirstImg = images[2];
          link.dataset.productVariantSecondImg = images[1];
          link.dataset.productVariantPrice = formatPriceEUR(product);

          const img = document.createElement('img');
          img.src = product.featuredImage;
          img.alt = product.title;
          img.width = isMobile ? '90' : '100';
          img.height = isMobile ? '90' : '100';

          if (product.images?.length) {
            img.classList.add('variant-thumb', 'new');
            img.src = images[0];
            img.srcset = product.images.map(url => `${url} 500w`).join(', ');
          }

          link.appendChild(img);
          thumbsContainer.appendChild(link);

          showVariantThumbnailsSmoothly(thumbsContainer).then(() => {
            
            const links = thumbsContainer.querySelectorAll('.variant-highlight');
            let activeLink = null;

            // Remove .active from all, find the matching one
            links.forEach(link => {
              link.classList.remove('active');
              const variantId = link.dataset.productVariantId;
              if (variantId && baseId && variantId === baseId) {
                activeLink = link;
              }
            });

            // If no match found, pick the first
            if (!activeLink && links.length) {
              activeLink = links[0];
            }

            if (activeLink) {
              activeLink.classList.add('active');
              // activeLink.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
            }
          });
        });
      }
    }
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
 
  }

  function showVariantThumbnailsSmoothly(container) {
    const images = Array.from(container.querySelectorAll('img'));
    if (!images.length) return Promise.resolve();

    return Promise.all(
      images.map(img =>
        new Promise(resolve => {
          if (img.complete) resolve();
          else img.addEventListener('load', resolve, { once: true });
        })
      )
    ).then(() => {
      container.classList.add('loaded');
    });
  }

  function formatPriceEUR(product) {
    const priceMin = Number(product.price_min || product.price || 0);
    const priceMax = Number(product.price_max || product.price || 0);

    function format(p) {
      if (p >= 1000) {
        const value = p / 100;       // last 2 zeros represent thousands
        return value % 1 === 0 ? value.toString() : value.toFixed(3);
      }
      return Math.round(p).toString(); // small prices as-is
    }

    // For prices >= 1000, insert dot before hundreds
    // const str = p.toString();
    // const len = str.length;
    // return str.slice(0, len - 3) + '.' + str.slice(len - 3);

    const formattedMin = format(priceMin);
    const formattedMax = format(priceMax);

    if (formattedMin !== formattedMax) {
      return `EUR ${formattedMin} – EUR ${formattedMax}`;
    }
    return `EUR ${formattedMin}`;
  }

  // async function loadSpotlightHighlightVariants(container = document) {
  //   const cards = container.querySelectorAll('.product.spotlight, .product.highlight');

  //   for (const card of cards) {
  //     // Skip if already loaded
  //     if (card.dataset.loaded === 'true') continue;
  //     card.dataset.loaded = 'true';

  //     const thumbsContainer = card.querySelector('.variant-thumbnails');
  //     if (!thumbsContainer) continue;

  //     const variantHandles = card.dataset.variantProducts;
  //     if (!variantHandles) continue;

  //     const handles = variantHandles
  //       .split(',')
  //       .map(h => h.trim())
  //       .filter(Boolean);
  //     if (!handles.length) continue;

  //     const query = `
  //       query getProductByHandle($handle: String!) {
  //         product(handle: $handle) {
  //           id
  //           title
  //           handle
  //           onlineStoreUrl
  //           featuredImage {
  //             url
  //             altText
  //           }
  //           priceRange {
  //             minVariantPrice {
  //               amount
  //               currencyCode
  //             }
  //           }
  //         }
  //       }
  //     `;

  //     const relatedProducts = [];

  //     for (const handle of handles) {
  //       try {
  //         const res = await fetch('https://sease.it/api/2025-10/graphql.json', {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json',
  //             'X-Shopify-Storefront-Access-Token': '3e4eda6c69b97cbd516a85efc08d50e1'
  //           },
  //           body: JSON.stringify({ query, variables: { handle } })
  //         });

  //         const json = await res.json();
  //         const product = json?.data?.product;
  //         if (product) relatedProducts.push(product);
  //       } catch (err) {
  //         console.error('Error fetching product', handle, err);
  //       }
  //     }

  //     console.log(relatedProducts);

  //     // Render thumbnails if needed
  //     // relatedProducts.forEach(prod => {
  //     //   if (!prod.featuredImage?.url) return;
  //     //   const img = document.createElement('img');
  //     //   img.src = prod.featuredImage.url;
  //     //   img.alt = prod.featuredImage.altText || prod.title;
  //     //   img.classList.add('variant-thumb');
  //     //   img.loading = 'lazy';
  //     //   img.addEventListener('click', () => {
  //     //     window.location.href = prod.onlineStoreUrl;
  //     //   });
  //     //   thumbsContainer.appendChild(img);
  //     // });
  //   }
  // }

  // function initSpotlightHighlightHover(container = document) {
  //   // Select all spotlight/highlight products inside the container
  //   container.querySelectorAll('.product.spotlight, .product.highlight').forEach(card => {
  //     // Remove previous listener if exists
  //     if (card._mouseenterListener) {
  //       card.removeEventListener('mouseenter', card._mouseenterListener);
  //     }

  //     // Define async listener
  //     const listener = async () => {
  //       if (card.dataset.loaded === 'true') return;
  //       card.dataset.loaded = 'true';

  //       const thumbsContainer = card.querySelector('.variant-thumbnails');
  //       if (!thumbsContainer) return;

  //       const variantHandles = card.dataset.variantProducts;
  //       if (!variantHandles) return;

  //       const handles = variantHandles
  //         .split(',')
  //         .map(h => h.trim())
  //         .filter(Boolean);
  //       if (!handles.length) return;

  //       const query = `
  //         query getProductByHandle($handle: String!) {
  //           product(handle: $handle) {
  //             id
  //             title
  //             handle
  //             onlineStoreUrl
  //             featuredImage {
  //               url
  //               altText
  //             }
  //             priceRange {
  //               minVariantPrice {
  //                 amount
  //                 currencyCode
  //               }
  //             }
  //           }
  //         }
  //       `;

  //       const relatedProducts = [];

  //       for (const handle of handles) {
  //         try {
  //           const res = await fetch('https://sease.it/api/2025-10/graphql.json', {
  //             method: 'POST',
  //             headers: {
  //               'Content-Type': 'application/json',
  //               'X-Shopify-Storefront-Access-Token': '3e4eda6c69b97cbd516a85efc08d50e1'
  //             },
  //             body: JSON.stringify({ query, variables: { handle } })
  //           });

  //           const json = await res.json();
  //           const product = json?.data?.product;
  //           if (product) relatedProducts.push(product);
  //         } catch (err) {
  //           console.error('Error fetching product', handle, err);
  //         }
  //       }

  //       console.log(relatedProducts);

  //       // Render thumbnails if needed
  //       // relatedProducts.forEach(prod => {
  //       //   if (!prod.featuredImage?.url) return;
  //       //   const img = document.createElement('img');
  //       //   img.src = prod.featuredImage.url;
  //       //   img.alt = prod.featuredImage.altText || prod.title;
  //       //   img.classList.add('variant-thumb');
  //       //   img.loading = 'lazy';
  //       //   img.addEventListener('click', () => {
  //       //     window.location.href = prod.onlineStoreUrl;
  //       //   });
  //       //   thumbsContainer.appendChild(img);
  //       // });
  //     };

  //     // Store the listener reference on the element
  //     card._mouseenterListener = listener;

  //     // Add the listener
  //     card.addEventListener('mouseenter', listener);
  //   });
  // }
  
};

// swiping over hightlight/spotlight variant-thumbnails on mobile
